import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import programs from './programs/reducers'
import customerDetail from './customers/reducers'
import partners from './partners/reducers'
import promotions from './promotions/reducers'
import subscription from './subscription/reducers'
import common from './common/reducers'
import surveyQuestions, { surveyQuestionTypes } from './survey/reducers'
import cardDesign from './card-design/reducers'
import giftCardDesign from './gift-card-design/reducers'
import allowanceCardDesign from './allowance-card-design/reducers'
import brand from './brand/reducers'
import items from './items/reducers'
import { entities } from './entities'
import pagination from './pagination/reducers'
import customerTags from './customer-tags/reducers'
import inbox from './inbox/conversations/reducers'

const allReducers = history =>
  combineReducers({
    router: connectRouter(history),
    entities,
    user,
    menu,
    settings,
    programs,
    customerDetail,
    partners,
    promotions,
    subscription,
    common,
    surveyQuestions,
    surveyQuestionTypes,
    cardDesign,
    giftCardDesign,
    allowanceCardDesign,
    brand,
    items,
    pagination,
    customerTags,
    inbox,
  })

export default allReducers
